import './styles.scss'

import React from 'react'
import { useValues, useActions } from 'kea'

import I18n from 'lib/i18n'
import redirect from 'lib/utils/redirect-url'

import courseLogic from '~/scenes/course/show/logic'

export default function BottomFloat () {
  const {
    windowWidth,
    course: { messageUrl, messageUrlIsInbox },
    user: { firstName }
  } = useValues(courseLogic)
  const { openModal } = useActions(courseLogic)

  const handleMessageClick = () => {
    if (!messageUrlIsInbox && windowWidth >= 760) {
      openModal()
    } else {
      redirect(messageUrl)
    }
  }

  return (
    <div className='only-responsive course-bottom-float'>
      <button className='class-button' onClick={handleMessageClick}>
        {I18n.t('courses.show_contact.button', { first_name: firstName })}
      </button>
    </div>
  )
}
